import { Routes } from '@angular/router';
import { hisRootRoutes } from 'hisng';

export const ROUTES: Routes = [
    {
        path: 'person',
        loadChildren: () => import( './cs/psv/person/person-core.module' ).then( m => m.PersonCoreModule ),
        data: {
            modules: ['HISINONEPSV']
        }
    },
    {
        path: 'identityprovider',
        loadChildren: () => import( './cs/psv/identityprovider/identityprovider-core.module' ).then( m => m.IdentityproviderCoreModule ),
        data: {
            modules: ['HISINONEPSV']
        }
    },
    {
        path: 'externaldatamodel',
        loadChildren: () => import( './cs/psv/external-data-model/external-data-model-core.module' ).
            then( m => m.ExternalDataModelCoreModule ),
        data: {
            modules: ['HISINONEPSV']
        }
    },
    {
        path: 'objectgroup',
        loadChildren: () => import( './cs/psv/object-group/object-group-core.module' ).
            then( m => m.ObjectGroupCoreModule ),
        data: {
            modules: ['HISINONEPSV']
        }
    },
    {
        path: 'paramexternalsys',
        loadChildren: () => import( './cs/psv/interface/external/interface-configuration-core.module' )
            .then( m => m.InterfaceConfigurationCoreModule ),
        data: {
            modules: ['HISINONEPSV', 'HISINONERES']
        }
    },
    {
        path: 'orcidexport',
        loadChildren: () => import( './cs/psv/orcid-export/orcid-id-link-core.module' ).then( m => m.OrcidIdLinkCoreModule ),
        data: {
            modules: ['HISINONEPSV']
        }
    },
];

// eslint-disable-next-line @typescript-eslint/naming-convention
export const AppRoutesModule = hisRootRoutes(ROUTES);
